import { render, staticRenderFns } from "./TableUsage.vue?vue&type=template&id=5aacff0b&"
import script from "./TableUsage.vue?vue&type=script&lang=ts&"
export * from "./TableUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports